var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M4.95 17.794a4.75 4.75 0 0 1-3.357-8.125l2.638-2.632a4.74 4.74 0 0 1 6.713 0q.351.34.624.744a.67.67 0 1 1-1.118.738 3.412 3.412 0 0 0-5.25-.531l-2.638 2.637a3.403 3.403 0 1 0 4.813 4.813l1.312-1.313a.672.672 0 1 1 .95.95l-1.312 1.313a4.73 4.73 0 0 1-3.375 1.406"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M10.412 12.331a4.74 4.74 0 0 1-3.356-1.387 4.6 4.6 0 0 1-.625-.744.67.67 0 1 1 1.119-.737q.195.284.437.53a3.41 3.41 0 0 0 4.813 0l2.637-2.637a3.403 3.403 0 1 0-4.812-4.812L9.312 3.856a.672.672 0 0 1-.95-.95l1.313-1.312a4.75 4.75 0 1 1 6.712 6.719l-2.631 2.63a4.75 4.75 0 0 1-3.344 1.388"
  })));
};
export default SvgShare;